import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ChototIcons from '@assets/styles/chotot-icons.module.scss';
// import { Stars } from '@app/components/GridAdsProject/AdItem/AdBody/Stars';
import { numberWithCommas, fromNow } from '@app/utils';
import Style from '../AdItem.module.scss';
import LabelAd from '../../LabelAd';

const AdBody = ({
  type,
  title,
  address,
  intro,
  price,
  // adTypeConfig = { adType: 's,k' },
  priceAd,
  titleAd,
  // ribbonAd,
  commonStyle,
  adParams,
  giveaway,
  data: {
    ad_count: adCount,
    // review_rating: reviewRating,
    is_verified: isVerified,
    created_date: createdDate,
  },
  lastUpdatedTime,
}) => {
  const htmlLabelTitleAd = titleAd && (
    <LabelAd labelInfo={titleAd} commonClass={`${commonStyle.commonStyleLabelGrid}`} />
  );

  const htmlLabelPriceAd = priceAd && (
    <LabelAd labelInfo={priceAd} commonClass={`${commonStyle.commonStyleLabelPriceGrid}`} />
  );

  const _renderPrice = () => {
    if (giveaway === true) {
      return (
        <span className={commonStyle.giveaway}>
          <i className={`${ChototIcons.icon} ${commonStyle.giveaway_icon}`} />
          <span className={commonStyle.giveawayText}>Cho tặng</span>
        </span>
      );
    }
    return (
      <div className={Style.wrapperPrice}>
        <span className={Style.price}>{price && price.length > 0 ? price : ''}</span>
        {htmlLabelPriceAd}
      </div>
    );
  };

  let styleAdTitle = `${commonStyle.adTitleGrid} ${commonStyle.adTitleBold} `;
  let styleAdBody =
    type === 'agent'
      ? `${Style.caption} ${Style.captionAgent} ${Style.center} ${Style.twoline}`
      : `${Style.caption} ${Style.threeline}`;

  styleAdBody = type === 'project' ? `${Style.caption}` : styleAdBody;

  if (type === 'blog') {
    styleAdTitle += `${commonStyle.adTitleBlog}`;
  }
  if (type === 'agent') {
    styleAdTitle += `${commonStyle.adTitleAgent}`;
  }

  // const breakTitle = title.length > 70;
  // if (titleAd && title.length > 35) {
  //   title = title.substring(0, 35).concat('...');
  // } else {
  //   title = breakTitle ? title.substring(0, 50).concat('...') : title;
  // }

  return (
    <div className={styleAdBody}>
      <div className={styleAdTitle}>
        {htmlLabelTitleAd}
        {title}
        {/* {title && title.length > 50 ? `${title.substr(0, 30)}...` : title}{' '} */}
        {type === 'agent' && isVerified ? (
          <img
            style={{ verticalAlign: 'middle' }}
            width="12px"
            alt="Verified"
            src="https://static.chotot.com/storage/chotot-icons/svg/shop-front/verify.svg"
          />
        ) : null}
      </div>
      {type !== 'blog' ? (
        <div className={Style.address}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="14"
            height="16"
            viewBox="0 0 14 16"
          >
            <defs>
              <path id="prefix__a" d="M14 0L14 16 0 16 0 0 14 0z" />
            </defs>
            <g fill="none" fillRule="evenodd" opacity=".431">
              <mask id="prefix__b" fill="#fff">
                <use xlinkHref="#prefix__a" />
              </mask>
              <g mask="url(#prefix__b)">
                <path
                  fill="#000"
                  d="M6.131 0C2.745 0 0 2.657 0 5.934c0 1.594.653 3.116 1.709 4.262l4.422 4.977 4.423-4.977c1.056-1.146 1.709-2.668 1.709-4.262C12.263 2.657 9.518 0 6.13 0m0 .898c2.87 0 5.204 2.26 5.204 5.036 0 1.313-.537 2.648-1.473 3.664l-.006.006-.006.006-3.719 4.186L2.413 9.61l-.006-.006-.006-.006C1.465 8.582.928 7.247.928 5.934.928 3.157 3.262.898 6.131.898"
                />
                <path
                  stroke="#000"
                  strokeWidth=".96"
                  d="M6.131 8.202c-1.317 0-2.384-1.033-2.384-2.307 0-1.275 1.067-2.308 2.384-2.308S8.516 4.62 8.516 5.895c0 1.274-1.068 2.307-2.385 2.307"
                />
              </g>
            </g>
          </svg>
          {address}
        </div>
      ) : null}

      {type === 'agent' ? (
        <div className={Style.intro}>
          {/* {reviewRating > 0 ? <Stars rating={reviewRating} /> : null} */}
        </div>
      ) : null}

      {type === 'agent' ? (
        <div className={Style.subIntro}>
          {numberWithCommas(adCount)} tin đăng . Thành viên từ {createdDate.substring(0, 4)}
        </div>
      ) : null}

      {type === 'blog' && intro && intro.length > 0 ? (
        <div className={Style.description}>{intro}</div>
      ) : null}

      <div className={Style.conditionWrapper}>
        <span className={Style.condition}>{adParams.join(' - ')}</span>
      </div>
      {_renderPrice()}
      <div className={Style.wrapperDate}>{fromNow(lastUpdatedTime)}</div>
    </div>
  );
};

AdBody.defaultProps = {
  type: null,
  intro: null,
  titleAd: null,
  priceAd: null,
  price: '',
  giveaway: false,
  adParams: [],
  adTypeConfig: null,
};

AdBody.propTypes = {
  intro: PropTypes.string,
  price: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string.isRequired,
  adTypeConfig: PropTypes.shape({
    adType: PropTypes.string,
  }),
  commonStyle: PropTypes.objectOf(PropTypes.string).isRequired,
  titleAd: PropTypes.oneOfType([() => null, PropTypes.object]),
  priceAd: PropTypes.oneOfType([() => null, PropTypes.object]),
  giveaway: PropTypes.bool,
  adParams: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
};

export default memo(AdBody);
